module.exports = __webpack_public_path__ + "assets/img/2.aad89293.png";